module.exports = __webpack_public_path__ + "img/logo-black.5dd3b614.svg";